import { useState, useCallback } from 'react';

export interface PopoverPayload {
  autoFocus?: boolean;
  popoverId?: string;
  history?: any;
  location?: any;
}

export interface UseFilterPopoverReturn {
  isOpen: boolean;
  payload: PopoverPayload | null;
  showPopover: (payload: PopoverPayload) => void;
  dismissPopover: () => void;
}

export const useFilterPopover = (): UseFilterPopoverReturn => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [payload, setPayload] = useState<PopoverPayload | null>(null);

  const showPopover = useCallback((popoverPayload: PopoverPayload) => {
    setPayload(popoverPayload);
    setIsOpen(true);
  }, []);

  const dismissPopover = useCallback(() => {
    setIsOpen(false);
    setPayload(null);
  }, []);

  return {
    isOpen,
    payload,
    showPopover,
    dismissPopover
  };
};
